import { Component, computed, input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ReferenceDatum } from '@sondermind/data-access/reference-data';
import { DropdownOption } from '@sondermind/iris/dropdown';

@Component({
  selector: 'member-profile-specialty-selector',
  templateUrl: './profile-specialty-selector.component.html',
  styleUrls: ['./profile-specialty-selector.component.scss'],
  standalone: false
})
export class ProfileSpecialtySelectorComponent {
  readonly form = input.required<UntypedFormGroup>();
  readonly label = input.required<string>();
  readonly name = input.required<string>();
  readonly specialtiesRefData = input.required<ReferenceDatum[]>();

  readonly specialtyOptions = computed(() => (this.specialtiesRefData() ?? []).map((s) => ({
    name: s.title,
    value: s.id
  } as DropdownOption<number>)));

  get formValue(): string {
    const specialties = this.specialtiesRefData();
    const val = this.form().controls[this.name()].getRawValue() as number | undefined;
    return specialties.find((s) => s.id === val)?.title || '';
  }
}
